// Warna area cluster yang berbeda
export const AreaColors = [
  { background: "rgba(255, 0, 0, 0.4)", border: "rgba(255, 0, 0, 0.8)" }, // Area 1
  {
    background: "rgba(255, 246, 77, 0.4)",
    border: "rgba(255, 246, 77, 0.8)",
  }, // Area 2
  { background: "rgba(0, 200, 83, 0.4)", border: "rgba(0, 200, 83, 0.8)" }, // Area 3
  {
    background: "rgba(33, 150, 243, 0.4)",
    border: "rgba(33, 150, 243, 0.8)",
  },
  {
    background: "rgba(156, 39, 176, 0.4)",
    border: "rgba(156, 39, 176, 0.8)",
  },
  { background: "rgba(255, 87, 34, 0.4)", border: "rgba(255, 87, 34, 0.8)" }, // Area 5
  { background: "rgba(63, 81, 181, 0.4)", border: "rgba(63, 81, 181, 0.8)" }, // Area 6
  { background: "rgba(0, 150, 136, 0.4)", border: "rgba(0, 150, 136, 0.8)" }, // Area 7
  {
    background: "rgba(205, 220, 57, 0.4)",
    border: "rgba(205, 220, 57, 0.8)",
  }, // Area 8
  { background: "rgba(121, 85, 72, 0.4)", border: "rgba(121, 85, 72, 0.8)" }, // Area 9
  {
    background: "rgba(96, 125, 139, 0.4)",
    border: "rgba(96, 125, 139, 0.8)",
  }, // Area 10
];
